import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/content";

const cardClasses = [
  "service-bento-wide",
  "service-bento-tall",
  "",
  "",
  "service-bento-wide",
  "",
];

export default function ServicesGrid({ compact = false, index = "03" }: { compact?: boolean; index?: string }) {
  return (
    <section id="services" data-testid="services-grid" className="relative py-24 md:py-32">
      <div className="container-edx">
        <div className="section-heading-grid">
          <div>
            <div className="section-index">EDX.{index}</div>
            <h2 className="section-display mt-5">
              BUILT TO SOLVE<br /><span className="gradient-text">REAL PROBLEMS.</span>
            </h2>
          </div>
          <div className="section-intro">
            <span>SELECT CAPABILITY //</span>
            <p>
              Strategy, design, engineering, intelligence, and ongoing support
              connected through one accountable delivery team.
            </p>
          </div>
        </div>

        <div className="service-bento mt-14">
          {SERVICES.map((service, index) => {
            const Icon = (Icons as any)[service.icon] || Icons.Sparkles;
            return (
              <motion.article
                key={service.title}
                data-testid={`service-card-${index}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                className={`service-bento-card service-accent-${service.accent} ${cardClasses[index]}`}
              >
                <div className="service-card-top">
                  <span>0{index + 1}</span>
                  <Icon size={22} />
                </div>
                <div>
                  <p className="service-card-kicker">CAPABILITY MODULE</p>
                  <h3>{service.title}</h3>
                  <p className="service-card-copy">{service.desc}</p>
                </div>
                <ul>
                  {service.items.map((item) => (
                    <li key={item}><ChevronRight size={12} />{item}</li>
                  ))}
                </ul>
                <Link to="/capabilities" aria-label={`Explore ${service.title}`}>
                  Explore module <ArrowUpRight size={15} />
                </Link>
              </motion.article>
            );
          })}
        </div>

        {compact && (
          <div className="mt-10 flex justify-end">
            <Link to="/capabilities" className="btn btn-ghost">
              View all capabilities <ArrowUpRight size={15} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
